import { createFileRoute } from "@tanstack/react-router";
import {
  CmsRoutePage,
  loadCmsRoute,
  normalizeRouteSearchParams,
  renderCmsHead,
} from "@core/cms/cms-route";

export const Route = createFileRoute("/")({
  validateSearch: normalizeRouteSearchParams,
  loader: ({ context, location }) =>
    loadCmsRoute({
      context,
      path: "/",
      searchParams: normalizeRouteSearchParams(location.search),
    }),
  head: ({ loaderData }) => renderCmsHead(loaderData?.seo),
  component: IndexPage,
});

function IndexPage() {
  const data = Route.useLoaderData();
  return <CmsRoutePage data={data} />;
}
